import { useState } from "react";
import { MapPin, X, Settings, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface LocationBlockedInfoProps {
  isIOS: boolean;
  onClose: () => void;
}

export const LocationBlockedInfo = ({ isIOS, onClose }: LocationBlockedInfoProps) => {
  return (
    <div className="bg-card border border-border rounded-xl shadow-lg overflow-hidden">
      {/* Header */}
      <div className="bg-primary/10 px-4 py-3 flex items-center justify-between border-b border-border">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center">
            <AlertCircle className="w-4 h-4 text-orange-600" />
          </div>
          <span className="font-medium text-sm text-foreground">
            Lokalizacja zablokowana
          </span>
        </div>
        <button
          onClick={onClose}
          className="p-1.5 rounded-full hover:bg-muted transition-colors text-muted-foreground hover:text-foreground"
          aria-label="Zamknij"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      {/* Content */}
      <div className="p-4">
        <p className="text-sm text-muted-foreground mb-3">
          {isIOS
            ? "Aby włączyć lokalizację na iOS:"
            : "Aby włączyć lokalizację:"}
        </p>

        <ol className="space-y-2 text-sm">
          {isIOS ? (
            <>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-primary/10 text-primary text-xs font-medium flex items-center justify-center shrink-0 mt-0.5">
                  1
                </span>
                <span className="text-foreground">
                  Otwórz <strong>Ustawienia</strong> iPhone/iPad
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-primary/10 text-primary text-xs font-medium flex items-center justify-center shrink-0 mt-0.5">
                  2
                </span>
                <span className="text-foreground">
                  Przewiń do <strong>Safari</strong>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-primary/10 text-primary text-xs font-medium flex items-center justify-center shrink-0 mt-0.5">
                  3
                </span>
                <span className="text-foreground">
                  Kliknij <strong>Lokalizacja</strong>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-primary/10 text-primary text-xs font-medium flex items-center justify-center shrink-0 mt-0.5">
                  4
                </span>
                <span className="text-foreground">
                  Wybierz <strong>Pytaj</strong> lub <strong>Zezwalaj</strong>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-primary/10 text-primary text-xs font-medium flex items-center justify-center shrink-0 mt-0.5">
                  5
                </span>
                <span className="text-foreground">
                  Wróć tutaj i <strong>odśwież stronę</strong>
                </span>
              </li>
            </>
          ) : (
            <>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-primary/10 text-primary text-xs font-medium flex items-center justify-center shrink-0 mt-0.5">
                  1
                </span>
                <span className="text-foreground">
                  Kliknij ikonę kłódki/info w pasku adresu
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-primary/10 text-primary text-xs font-medium flex items-center justify-center shrink-0 mt-0.5">
                  2
                </span>
                <span className="text-foreground">
                  Znajdź <strong>Lokalizacja</strong> i zmień na <strong>Zezwalaj</strong>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-primary/10 text-primary text-xs font-medium flex items-center justify-center shrink-0 mt-0.5">
                  3
                </span>
                <span className="text-foreground">
                  <strong>Odśwież stronę</strong>
                </span>
              </li>
            </>
          )}
        </ol>

        <Button
          variant="outline"
          size="sm"
          className="w-full mt-4"
          onClick={() => window.location.reload()}
        >
          Odśwież stronę
        </Button>
      </div>
    </div>
  );
};
